import React from 'react';
import { HexColorPicker } from 'react-colorful';

import { Box, TextField, Typography } from '@mui/material';

export interface IngressProps {
  title?: string;
  paragraph?: string;
  lineColor?: string;
}

interface IngressEditorProps {
  title?: string;
  paragraph?: string;
  lineColor?: string;
  onPropChange: (key: string, value: any) => void;
}

const IngressEditor: React.FC<IngressEditorProps> = ({
  title = '',
  paragraph = '',
  lineColor = '#000000',
  onPropChange,
}) => {
  return (
    <Box>
      <TextField
        label="Title"
        value={title}
        onChange={(e) => onPropChange('title', e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Paragraph"
        value={paragraph}
        onChange={(e) => onPropChange('paragraph', e.target.value)}
        multiline
        rows={4}
        fullWidth
        margin="normal"
      />
      <Box mt={2}>
        <Typography variant="subtitle2">Line Color</Typography>
        <TextField
          label="Line Color"
          value={lineColor || ''}
          onChange={(e) => onPropChange('lineColor', e.target.value)}
          fullWidth
          margin="dense"
        />
        <Box mt={1}>
          <HexColorPicker
            color={lineColor || '#000000'}
            onChange={(color) => onPropChange('lineColor', color)}
            style={{ width: '100%', maxWidth: '250px' }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default IngressEditor;
